module.exports = __webpack_public_path__ + "static/media/RWFKO1024465_sm2.4598209c.png";